<template>
  <v-flex xs12 md12 class="mt-2 mb-0 pb-0 mx-0 px-0">
    <div class="mx-3 mt-5">
    <v-tabs class="rounded light-shadow">
      <v-tab v-for="tab in tabs.filter((item)=>item.is_visible)" :to="{ path: tab.path }" :key="tab.title" append>
        {{$t(tab.title)}}
      </v-tab>
    </v-tabs>
    </div>
    <v-tabs-items v-model="tabIndex">
      <v-tab-item v-for="tab in tabs" :key="tab.path" class="px-3 pb-1 transparent-body">
        <router-view></router-view>
      </v-tab-item>
    </v-tabs-items>
  </v-flex>
</template>

<script>
export default {
  data: () => ({
    tabIndex: 0,
    tabs:[
      {
        title: 'viewGoods.title',
        path: '/storage/',
        is_visible: ! process.env.VUE_APP_IS_ENABLED_STORAGE_V2,
      },
      {
        title: 'goods.remains',
        path: '/storage/goods-remains/',
        is_visible: process.env.VUE_APP_IS_ENABLED_STORAGE_V2
      },
      {
        title: 'viewStorages.title',
        path: '/storage/storages/',
        is_visible: true,
      },
      {
        title: 'goods.incoming',
        path: '/storage/goods-incoming/',
        is_visible: process.env.VUE_APP_IS_ENABLED_STORAGE_V2
      },
      {
        title: 'goods.relocations',
        path: '/storage/goods-relocation/',
        is_visible: process.env.VUE_APP_IS_ENABLED_STORAGE_V2
      },
      {
        title: 'goods.writeoffs',
        path: '/storage/goods-writeoff/',
        is_visible: process.env.VUE_APP_IS_ENABLED_STORAGE_V2
      }
    ]
  }),
}
</script>

<style>

</style>
